import { Component } from '@angular/core';

@Component({
  selector: 'app-booking-garage',
  templateUrl: './booking-garage.component.html',
  styleUrls: ['./booking-garage.component.scss']
})
export class BookingGarageComponent {

}
